(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/views/payout-tables.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/views/payout-tables.js');

'use strict';

svs.numbergames.results.views.PayoutTables = Marionette.View.extend({
  initialPayoutType: 'extra',
  className: 'ng-payout-bg',
  regions: {
    payoutTablesRegion: '#payoutTablesRegion'
  },
  ui: {
    payoutSelect: '.js-payout-select'
  },
  triggers: {
    'change @ui.payoutSelect': 'changeVisiblePayout'
  },
  template(data) {
    return svs.numbergames.results.templates.payout_tables(data);
  },
  templateContext() {
    return {
      initialPayoutType: this.initialPayoutType
    };
  },
  onRender() {
    this.showChildView('payoutTablesRegion', new Marionette.CollectionView({
      className: 'ng-payout-flex',
      childView: svs.numbergames.results.views.PayoutTable,
      collection: this.model.get('payouts'),
      viewFilter: child => child.model.get('payoutType') === this.initialPayoutType
    }));
  },
  onChangeVisiblePayout(view, event) {
    this.getChildView('payoutTablesRegion').setFilter(child => child.model.get('payoutType') === event.target.value);
  }
});

 })(window);